import React from 'react';
import PropTypes from 'prop-types';
import {useComponentProps, useEffectItem} from 'helpers/hooks/utils';
import StyledInsightsList from 'components/organisms/Lists/InsightsList/InsightsList.styles';
import Component from 'components/organisms/Utils/Component/Component';
import InsightCard from 'components/molecules/Cards/InsightCard/InsightCard';
import utils from 'helpers/utils';

const InsightsList = React.forwardRef((props, ref) => {
  const {
    insights,
    Card,
    onClick,
    isLoading,
    loaderCount,
    InsightCardProps,
    ...innerProps
  } = useComponentProps({
    loaderCount: 6,
    ...props
  }, 'InsightsList');

  const InsightCardDefault = ({insight, ...props}) => {
    return <InsightCard insight={insight}
                        fullWidth={true}
                        {...props}/>
  };

  const CardMemo = useEffectItem(Card ?? InsightCardDefault);
  const renderCard = (insight, state) => {
    return <Component Original={CardMemo}
                      insight={insight}
                      selected={state.selected}
                      onClick={!state.isLoading ? onClick : null}
                      isLoading={state.isLoading}
                      {...InsightCardProps} />
  };

  const isItemEqual = (insight, selected) => {
    return +insight.insightId === +selected.insightId;
  }

  return <StyledInsightsList ref={ref} {...innerProps}
                             data={insights?.data}
                             count={insights.meta?.resultsCount}
                             dataKey="insightId"
                             isItemEqual={isItemEqual}
                             renderItem={renderCard}
                             isLoading={isLoading || (insights.status.isLoading || !utils.isDefined(insights?.data))}
                             showProgressBar={insights.status.isLoadingNext}
                             onFetchMore={insights.query?.fetchNextPage}
                             loaderCount={loaderCount}
                             ListProps={{
                               track: true,
                               virtualize: true,
                               overscan: 1,
                               estimatedSize: 156,
                               gap: 8,
                             }}/>
});

InsightsList.propTypes = {
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func
  ]),
  insights: PropTypes.object,
  Card: PropTypes.any,
  onClick: PropTypes.func,
  isLoading: PropTypes.bool,
  loaderCount: PropTypes.number,
  InsightCardProps: PropTypes.object
};

export default InsightsList;
